var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scale",class:[
    _vm.lock && 'scale--lock',
    _vm.not && 'effect' ]},[_c('div',{staticClass:"scale__progress",class:("scale__progress--" + _vm.face),style:({ width: _vm.progress + '%' })})])}
var staticRenderFns = []

export { render, staticRenderFns }